import React, { useState } from "react";
import { MessageCircle, X, Phone } from "lucide-react";
import { COMPANY } from "../data";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);

  const buildLink = (raw) => {
    const text = encodeURIComponent(
      "Hello MRL Transports, I would like to enquire about your transportation services."
    );
    return `https://wa.me/${raw}?text=${text}`;
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="whatsapp-fab">
      {open && (
        <div
          className="bg-white shadow-2xl border-2 border-brand-green w-72 overflow-hidden animate-fade-up"
          data-testid="whatsapp-panel"
        >
          <div className="bg-brand-green text-white px-4 py-3 flex items-center justify-between">
            <div>
              <p className="font-heading text-sm uppercase tracking-widest">Chat with us</p>
              <p className="font-mono text-[10px] opacity-80">MRL Transports • Namakkal</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="hover:opacity-80"
              aria-label="Close chat panel"
              data-testid="whatsapp-close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-4 space-y-2">
            <p className="font-body text-xs text-zinc-600 leading-relaxed mb-3">
              Reach our team instantly on WhatsApp for quotes, fleet availability or project queries.
            </p>
            {COMPANY.phones.map((p) => (
              <a
                key={p.raw}
                href={buildLink(p.raw)}
                target="_blank"
                rel="noreferrer"
                data-testid={`whatsapp-link-${p.raw}`}
                className="flex items-center justify-between border-2 border-zinc-200 hover:border-brand-green hover:bg-brand-green hover:text-white transition-colors p-3 group"
              >
                <div className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-brand-orange group-hover:text-white" />
                  <div>
                    <p className="font-heading text-xs uppercase tracking-widest">{p.label}</p>
                    <p className="font-mono text-xs">{p.value}</p>
                  </div>
                </div>
                <MessageCircle className="w-5 h-5 text-brand-green group-hover:text-white" />
              </a>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Open WhatsApp chat"
        data-testid="whatsapp-fab-button"
        className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white shadow-2xl transition-transform hover:scale-110"
        style={{ backgroundColor: "#25D366" }}
      >
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8" />
        <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ backgroundColor: "#25D366" }} />
      </button>
    </div>
  );
}
